import { Collapse } from '@shape-ds/components';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CollapseTitle } from '../Collapse/CollapseTitle';
import { SavingsForm } from './SavingsForm';

export const Savings = () => {
  const { t } = useTranslation();
  const hasSavings = useWatch({
    name: 'has_savings',
  });
  const [isOpen, setIsOpen] = useState<boolean>(hasSavings);

  useEffect(() => {
    setIsOpen(hasSavings);
  }, [hasSavings]);

  const savingsStatus = hasSavings ? 'yes' : 'no';

  return (
    <Collapse
      className="collapse-group"
      isOpen={isOpen}
      toggleIsOpen={() => setIsOpen(!isOpen)}
      title={
        <CollapseTitle
          title={t('case:savings.title')}
          button={{ text: t(`case:savings.has_savings.${savingsStatus}`) }}
        />
      }
    >
      <SavingsForm />
    </Collapse>
  );
};
